document.documentElement.classList.remove('no-js');


/* =========================================================
   RESPONSIVE SLIDESHOW
   ========================================================= */

(function () {

  function initSlideshow(root) {

    if (!root || root.dataset.slideshowReady === 'true') return;

    root.dataset.slideshowReady = 'true';

    const slides = Array.from(
      root.querySelectorAll('[data-slideshow-slide]')
    );

    const dots = Array.from(
      root.querySelectorAll('[data-slideshow-dot]')
    );

    const prev = root.querySelector('[data-slideshow-prev]');
    const next = root.querySelector('[data-slideshow-next]');

    const autoplay = root.dataset.autoplay === 'true';

    const interval = Math.max(
      parseInt(root.dataset.interval || '5000', 10),
      3000
    );

    let index = 0;
    let timer = null;


    if (slides.length <= 1) return;


    function showSlide(newIndex) {

      index = (newIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {

        slide.classList.toggle(
          'is-active',
          i === index
        );

      });


      dots.forEach(function (dot, i) {

        const active = i === index;

        dot.classList.toggle(
          'is-active',
          active
        );

        if (active) {

          dot.setAttribute(
            'aria-current',
            'true'
          );

        } else {

          dot.removeAttribute(
            'aria-current'
          );

        }

      });

    }


    function stop() {

      if (timer) {
        window.clearInterval(timer);
      }

      timer = null;

    }


    function start() {

      stop();

      if (
        autoplay &&
        !window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {

        timer = window.setInterval(
          function () {
            showSlide(index + 1);
          },
          interval
        );

      }

    }


    if (prev) {

      prev.addEventListener(
        'click',
        function () {

          showSlide(index - 1);

          start();

        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        function () {

          showSlide(index + 1);

          start();

        }
      );

    }


    dots.forEach(function (dot) {

      dot.addEventListener(
        'click',
        function () {

          showSlide(
            parseInt(
              dot.dataset.slideshowDot,
              10
            )
          );

          start();

        }
      );

    });


    root.addEventListener(
      'mouseenter',
      stop
    );


    root.addEventListener(
      'mouseleave',
      start
    );


    root.addEventListener(
      'focusin',
      stop
    );


    root.addEventListener(
      'focusout',
      start
    );


    let touchStartX = 0;


    root.addEventListener(
      'touchstart',
      function (event) {

        touchStartX =
          event.changedTouches[0].screenX;

      },
      {
        passive: true
      }
    );


    root.addEventListener(
      'touchend',
      function (event) {

        const distance =
          event.changedTouches[0].screenX -
          touchStartX;


        if (Math.abs(distance) > 45) {

          showSlide(
            index +
            (
              distance < 0
                ? 1
                : -1
            )
          );

        }

        start();

      },
      {
        passive: true
      }
    );


    showSlide(0);

    start();

  }


  function initAllSlideshows(root) {

    (root || document)
      .querySelectorAll(
        '[data-responsive-slideshow]'
      )
      .forEach(initSlideshow);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAllSlideshows(document);

      }
    );

  } else {

    initAllSlideshows(document);

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllSlideshows(
        event.target
      );

    }
  );

})();



/* =========================================================
   MOBILE MENU
   ========================================================= */

(function () {

  let mobileMenuReady = false;


  function initMobileMenu() {

    if (mobileMenuReady) return;


    const open =
      document.querySelector(
        '[data-mobile-menu-open]'
      );

    const close =
      document.querySelector(
        '[data-mobile-menu-close]'
      );

    const overlay =
      document.querySelector(
        '[data-mobile-menu-overlay]'
      );

    const menu =
      document.querySelector(
        '[data-mobile-menu]'
      );


    if (!open || !menu) return;


    mobileMenuReady = true;


    function setMenu(isOpen) {

      document.body.classList.toggle(
        'mobile-menu-open',
        isOpen
      );


      open.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );


      menu.setAttribute(
        'aria-hidden',
        isOpen ? 'false' : 'true'
      );

    }


    open.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        setMenu(true);

      }
    );


    if (close) {

      close.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          setMenu(false);

        }
      );

    }


    if (overlay) {

      overlay.addEventListener(
        'click',
        function () {

          setMenu(false);

        }
      );

    }


    document.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {

          setMenu(false);

        }

      }
    );

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initMobileMenu
    );

  } else {

    initMobileMenu();

  }

})();



/* =========================================================
   PRODUCT GALLERY
   THUMBNAIL -> MAIN IMAGE
   ========================================================= */

(function () {

  function cleanImageUrl(url) {

    if (!url) return '';

    /*
      Convert protocol-relative Shopify URLs:
      //cdn.shopify.com/...
      to:
      https://cdn.shopify.com/...
    */

    if (url.indexOf('//') === 0) {

      url = 'https:' + url;

    }


    return url;

  }



  function getThumbnailImageUrl(thumb) {

    if (!thumb) return '';


    /*
      FIRST:
      use the full-size URL supplied by Liquid.

      Example:
      data-image-url="//cdn.shopify.com/..."
    */

    let url =
      thumb.getAttribute(
        'data-image-url'
      ) ||

      thumb.getAttribute(
        'data-image'
      ) ||

      thumb.getAttribute(
        'data-full-image'
      ) ||

      thumb.getAttribute(
        'data-src'
      );


    if (url) {

      return cleanImageUrl(url);

    }



    /*
      FALLBACK:
      get URL from thumbnail img
    */

    const img =
      thumb.tagName === 'IMG'
        ? thumb
        : thumb.querySelector('img');


    if (!img) return '';


    url =
      img.getAttribute(
        'data-full-image'
      ) ||

      img.getAttribute(
        'data-src'
      ) ||

      img.getAttribute(
        'src'
      ) ||

      img.currentSrc;


    return cleanImageUrl(url);

  }



  function changeMainProductImage(
    gallery,
    thumb
  ) {

    if (!gallery || !thumb) return;


    /*
      EXACT selector used by your theme
    */

    const mainImage =
      gallery.querySelector(
        '[data-product-main-image]'
      ) ||

      gallery.querySelector(
        '.product-main-image img'
      ) ||

      gallery.querySelector(
        '.product-gallery__main img'
      ) ||

      gallery.querySelector(
        '.product-media__main img'
      );


    if (!mainImage) {

      console.warn(
        'Extreme Watches gallery: main product image not found.'
      );

      return;

    }


    const newUrl =
      getThumbnailImageUrl(
        thumb
      );


    if (!newUrl) {

      console.warn(
        'Extreme Watches gallery: thumbnail image URL not found.'
      );

      return;

    }



    /*
      IMPORTANT:
      Remove responsive image attributes FIRST.

      Otherwise the browser may continue displaying
      the old Shopify srcset image.
    */

    mainImage.removeAttribute(
      'srcset'
    );

    mainImage.removeAttribute(
      'sizes'
    );

    mainImage.removeAttribute(
      'data-srcset'
    );

    mainImage.removeAttribute(
      'data-src'
    );



    /*
      If Shopify uses a <picture>,
      remove its old source sets too.
    */

    const picture =
      mainImage.closest(
        'picture'
      );


    if (picture) {

      picture
        .querySelectorAll(
          'source'
        )
        .forEach(
          function (source) {

            source.removeAttribute(
              'srcset'
            );

            source.removeAttribute(
              'data-srcset'
            );

            source.removeAttribute(
              'sizes'
            );

          }
        );

    }



    /*
      Set selected image as main image
    */

    mainImage.src = newUrl;


    /*
      Update common lazy-load attributes too
    */

    mainImage.setAttribute(
      'data-src',
      newUrl
    );


    /*
      Update zoom/lightbox link
      if main image is wrapped inside <a>
    */

    const mainLink =
      mainImage.closest('a');


    if (mainLink) {

      mainLink.setAttribute(
        'href',
        newUrl
      );

    }



    /*
      Update selected thumbnail styling
    */

    gallery
      .querySelectorAll(
        '[data-product-thumb]'
      )
      .forEach(
        function (item) {

          item.classList.remove(
            'is-active'
          );

          item.classList.remove(
            'active'
          );

          item.removeAttribute(
            'aria-current'
          );

        }
      );


    thumb.classList.add(
      'is-active'
    );


    thumb.setAttribute(
      'aria-current',
      'true'
    );


    /*
      Force browser repaint
    */

    mainImage.style.opacity = '0.15';


    requestAnimationFrame(
      function () {

        mainImage.style.opacity = '1';

      }
    );

  }



  function initProductGallery(
    gallery
  ) {

    if (!gallery) return;


    /*
      Prevent installing the same listener twice
    */

    if (
      gallery.dataset.galleryReady ===
      'true'
    ) {

      return;

    }


    gallery.dataset.galleryReady =
      'true';



    /*
      EVENT DELEGATION

      Works even if Shopify dynamically updates
      thumbnails later.
    */

    gallery.addEventListener(
      'click',
      function (event) {

        const thumb =
          event.target.closest(
            '[data-product-thumb]'
          );


        if (!thumb) return;


        /*
          Make sure clicked thumbnail belongs
          to this gallery
        */

        if (!gallery.contains(thumb)) {

          return;

        }


        event.preventDefault();

        event.stopPropagation();


        changeMainProductImage(
          gallery,
          thumb
        );

      }
    );



    /*
      Keyboard support
    */

    gallery.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !== 'Enter' &&
          event.key !== ' '
        ) {

          return;

        }


        const thumb =
          event.target.closest(
            '[data-product-thumb]'
          );


        if (!thumb) return;


        event.preventDefault();


        changeMainProductImage(
          gallery,
          thumb
        );

      }
    );



    /*
      Make thumbnails accessible/clickable
    */

    gallery
      .querySelectorAll(
        '[data-product-thumb]'
      )
      .forEach(
        function (thumb) {

          thumb.style.cursor =
            'pointer';


          if (
            thumb.tagName !== 'BUTTON' &&
            thumb.tagName !== 'A'
          ) {

            if (
              !thumb.hasAttribute(
                'tabindex'
              )
            ) {

              thumb.setAttribute(
                'tabindex',
                '0'
              );

            }


            if (
              !thumb.hasAttribute(
                'role'
              )
            ) {

              thumb.setAttribute(
                'role',
                'button'
              );

            }

          }

        }
      );

  }



  function initProductGalleries(
    root
  ) {

    const scope =
      root || document;


    /*
      If root itself is gallery
    */

    if (
      scope.matches &&
      scope.matches(
        '[data-product-gallery]'
      )
    ) {

      initProductGallery(
        scope
      );

    }



    /*
      Find galleries inside root
    */

    if (
      scope.querySelectorAll
    ) {

      scope
        .querySelectorAll(
          '[data-product-gallery]'
        )
        .forEach(
          initProductGallery
        );

    }

  }



  function startProductGallery() {

    initProductGalleries(
      document
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startProductGallery
    );

  } else {

    startProductGallery();

  }



  /*
    Shopify Theme Editor:
    section reloaded
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initProductGalleries(
        event.target
      );

    }
  );



  /*
    Shopify can sometimes update product HTML
    dynamically.

    This observer automatically initializes
    any newly inserted product gallery.
  */

  const observer =
    new MutationObserver(
      function (mutations) {

        mutations.forEach(
          function (mutation) {

            mutation
              .addedNodes
              .forEach(
                function (node) {

                  if (
                    node.nodeType !== 1
                  ) {

                    return;

                  }


                  initProductGalleries(
                    node
                  );

                }
              );

          }
        );

      }
    );


  function startObserver() {

    if (!document.body) return;


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );

  } else {

    startObserver();

  }

})();



/* =========================================================
   PRODUCT IMAGE LOADING TRANSITION
   ========================================================= */

(function () {

  document.addEventListener(
    'load',
    function (event) {

      const image =
        event.target;


      if (
        image &&
        image.matches &&
        image.matches(
          '[data-product-main-image]'
        )
      ) {

        image.classList.remove(
          'is-loading'
        );

      }

    },
    true
  );

})();